var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorneDIstanceD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 183.48V172.28L65.72 195.82V209.39L21.8 183.48Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.11 197.1L21.8 172.3L189.24 73.1703L229.34 93.0001L66.11 197.1Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5801 209.71V196.45L229.34 92.8802V104.31L65.5801 209.71Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.42 163.06L32.03 166.23L59.73 181.5L65.36 177.97L37.42 163.06Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6 146.37L60.21 149.55L87.9 164.84L93.53 161.31L65.6 146.37Z",
    fill: "#F97E73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9202 155.07L46.3301 157.8L64.4701 166.82L69.3501 163.71L50.9202 155.07Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9801 128.97L89.6001 132.17L117.37 147.32L122.98 143.76L94.9801 128.97Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.48 112.63L117.12 115.86L144.97 130.85L150.57 127.26L122.48 112.63Z",
    fill: "#F97E73"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.68 121.47L103.08 124.18L121.17 133.3L126.07 130.21L107.68 121.47Z",
    fill: "#F97E73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M150.14 96.3202L144.74 99.4901L172.42 114.8L178.05 111.28L150.14 96.3202Z",
    fill: "#F97E73"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M178.24 79.6803L172.86 82.8702L200.61 98.0502L206.23 94.5001L178.24 79.6803Z",
    fill: "#FECECA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.23 88.5702L158.63 91.2902L176.76 100.35L181.64 97.2501L163.23 88.5702Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.86 104.74L131.25 107.44L149.33 116.59L154.23 113.52L135.86 104.74Z",
    fill: "#F97E73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8 138.53L74.23 141.29L92.42 150.21L97.28 147.07L78.8 138.53Z",
    fill: "#F97E73"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M166.21 42.1603C173.42 36.6303 175.05 34.3302 175.05 30.8802C175.05 25.3702 170.66 23.4601 166.04 23.4601C163.33 23.4601 161.01 24.1302 158.97 25.1002L159.62 29.7601C160.82 29.0601 163.36 28.3102 165.42 28.3102C167.48 28.3102 169.21 28.8902 169.21 31.2902C169.21 32.9102 168.34 34.5002 166.52 36.1002L158.77 42.8802V46.9701H175.71V42.1603H166.21Z",
    fill: "#F97E73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M185.49 47.3102C191.13 47.3102 195.24 44.9601 195.24 39.2601C195.24 34.3501 190.98 31.9303 185.76 31.9303C185.08 31.9303 184.38 31.9802 184.04 32.0302L184.41 28.6302H194.24V23.8002H179.98L178.46 36.0902L179.52 36.9701C180.97 36.4801 182.65 36.2401 184.46 36.2401C187.65 36.2401 189.26 37.4001 189.26 39.4801C189.26 41.5601 187.79 42.5201 184.84 42.5201C182.74 42.5201 180.5 42.0403 178.36 40.9303L177.57 45.6903C179.74 46.7003 182.59 47.3102 185.49 47.3102Z",
    fill: "#F97E73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M219.45 46.9701H224.83V36.3302C224.83 32.3302 221.84 30.2501 218.69 30.2501C216.62 30.2501 214.51 31.1101 213.17 32.9801C212.3 31.1701 210.21 30.2501 208.02 30.2501C206.09 30.2501 204.12 30.8502 202.96 32.3202L202.79 30.5902H197.85V46.9701H203.23V37.8602C203.23 36.0402 204.61 35.1703 205.96 35.1703C207.31 35.1703 208.64 36.0402 208.64 37.8602V46.9701H214.01V37.8602C214.01 36.0402 215.43 35.1703 216.77 35.1703C218.11 35.1703 219.45 36.0402 219.45 37.8602V46.9701Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorneDIstanceD);
export default __webpack_public_path__ + "static/media/borneDIstanceD.4d2a104532b2a425571aa97911460c0b.svg";
export { ForwardRef as ReactComponent };